import type { UseFormRegisterReturn } from "react-hook-form";
import { authLink } from "./AuthLayout";
import { useT } from "../../i18n";

interface TermsCheckboxProps {
  registration: UseFormRegisterReturn;
  error?: string;
  className?: string;
}

export default function TermsCheckbox({
  registration,
  error,
  className,
}: TermsCheckboxProps) {
  const t = useT();
  const terms = t.auth.terms;
  return (
    <div className={className}>
      <label className="flex cursor-pointer items-start gap-2.5 text-[13px] leading-normal text-ink-soft">
        <input
          type="checkbox"
          aria-invalid={!!error}
          className="mt-0.5 h-4 w-4 shrink-0 accent-brand"
          {...registration}
        />
        <span>
          {terms.before}
          <a href="/terms" className={authLink}>
            {terms.termsLink}
          </a>
          {terms.middle}
          <a href="/privacy" className={authLink}>
            {terms.privacyLink}
          </a>
          {terms.after}
        </span>
      </label>
      {error && (
        <p className="mt-1 mb-0 text-xs text-tone-red-fg">{error}</p>
      )}
    </div>
  );
}
